import { render } from "./tracklist.vue?vue&type=template&id=35143f5e"
import script from "./tracklist.vue?vue&type=script&lang=js"
export * from "./tracklist.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__